// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ChromeFilledSvg from "@fishx/icons-svg/es/asn/ChromeFilled";
import FishxIcon from '../components/FishxIcon';

var ChromeFilled = function ChromeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ChromeFilledSvg
  }));
};

ChromeFilled.displayName = 'ChromeFilled';
export default React.forwardRef(ChromeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ChromeFilled.js
// module id = 2201
// module chunks = 0